import { getMessage } from "../../../lib/translator";

const PLACED_TYPES = [
  {
    text: getMessage("placed.for.today"),
    value: "PLACED_FOR_TODAY",
  },
  {
    text: getMessage("placed.today"),
    value: "PLACED_TODAY",
  },
];

export { PLACED_TYPES };
